import ToggleButton from "../../02-molecules/Buttons/buttonToggle";

export default class MainMenu extends ToggleButton {
  /**
   * creates an instance of ToggleButton
   * @extends ToggleButton
   */

  constructor() {
    super(); // call ToggleButton-Instance

    // classes
    this.hiddenClass = "js-hidden";
    this.visibleClass = "js-visible";
    this.activeClass = "active";

    // selectors
    this.subMenuSelector = ".egat-menu";
    this.levelThreeSubMenuSelector = ".egat-menu--level-3";
    this.toggleButtonSelector = "[data-js-button='toggle-button']";
    this.bottomMainMenuSelector = ".egat-navigation__bottom .egat-mainmenu";

    // elements
    this.navigation = document.querySelector(".egat-navigation");

    this.bottomMainMenu = document.querySelector(this.bottomMainMenuSelector);

    this.mobileMenuButton = document.querySelector(
      ".egat-navigation__top .egat-button--icon-only"
    );

    this.bottomMenuWrapper = document.querySelector(".egat-navigation__bottom");

    this.closeButton = this.bottomMenuWrapper.querySelector(
      ".egat-button--close"
    );

    this.mobileLevelOneMenu = document.querySelector(
      ".egat-navigation__bottom .egat-menu--level-1"
    );

    this.desktopLevelOneMenu = document.querySelector(
      ".egat-navigation__top .egat-menu--level-1"
    );

    // arrays
    this.toggleButtonArray = document.querySelectorAll(
      ".egat-menu__item--with-sub [data-js-button='toggle-button']"
    );

    this.topToggleButtonArray = document.querySelectorAll(
      ".egat-navigation__top .egat-menu__item--with-sub [data-js-button='toggle-button']"
    );

    this.closeButtonIcons = this.closeButton.querySelectorAll(".egat-icon");

    this.mobileButtonIcons =
      this.mobileMenuButton.querySelectorAll(".egat-icon");

    this.menuArray = document.querySelectorAll(".egat-navigation .egat-menu");

    this.bottomMenuArray = document.querySelectorAll(
      ".egat-navigation__bottom .egat-menu"
    );

    this.menuItemsArray = document.querySelectorAll(
      ".egat-navigation .egat-menu__item"
    );

    this.topLevelOneMenuItems = Array.from(
      document.querySelectorAll(
        ".egat-navigation__top .egat-menu--level-1 [data-js-menu-item='menu-item-1']"
      )
    );

    this.topLevelOneToggleButtons = Array.from(
      document.querySelectorAll(
        ".egat-navigation__top .egat-menu--level-1 [data-js-menu-item='menu-item-1'] [data-js-button='toggle-button']"
      )
    );

    this.bottomLevelOneMenuItems = Array.from(
      document.querySelectorAll(
        ".egat-navigation__bottom .egat-menu--level-1 [data-js-menu-item='menu-item-1']"
      )
    );

    this.bottomLevelOneToggleButtons = Array.from(
      document.querySelectorAll(
        ".egat-navigation__bottom .egat-menu--level-1 [data-js-menu-item='menu-item-1'] [data-js-button='toggle-button']"
      )
    );

    this.bottomLevelThreeMenus = Array.from(
      document.querySelectorAll(".egat-navigation__bottom .egat-menu--level-3")
    );

    // entry functions
    this.prepareComponents();
    this.onUserInteraction();
  }

  // helper functions

  // show top level one menu for desktop
  prepareComponents = () => {
    if (window.innerWidth >= 1440) {
      this.toggleMenu(this.desktopLevelOneMenu);
    }
  };

  handleClasses = (element, action, classes) => {
    switch (action) {
      case "add":
        element.classList.add(classes);
        break;
      case "remove":
        element.classList.remove(classes);
        break;
      case "toggle":
        element.classList.toggle(classes);
        break;
      default:
        break;
    }
  };

  // show/hide menu
  toggleMenu = (menu, setActiveClass) => {
    this.handleClasses(menu, "toggle", this.hiddenClass);

    // set optional active class
    if (setActiveClass) {
      this.handleClasses(menu.parentElement, "toggle", this.activeClass);
    }
  };

  // open menu
  openMenu = (menu, setActiveClass) => {
    this.handleClasses(menu, "remove", this.hiddenClass);
    // set optional active class
    if (setActiveClass) {
      this.handleClasses(menu.parentElement, "add", this.activeClass);
    }
  };

  // close menu
  closeMenu = (menu, setActiveClass) => {
    this.handleClasses(menu, "add", this.hiddenClass);
    // reset bottom navigation height

    // set optional active class
    if (setActiveClass) {
      this.handleClasses(menu.parentElement, "remove", this.activeClass);
    }
  };

  closeAll = () => {
    this.menuItemsArray.forEach(menuItem => {
      this.handleClasses(menuItem, "remove", this.activeClass);
    });
    this.menuArray.forEach(menu => {
      this.closeMenu(menu);
    });

    // reset bottom navigation height
    this.resetHeight(this.bottomMainMenu);

    // if top level one button is expanded, toggle expanded state
    this.bottomLevelOneToggleButtons.forEach(button => {
      if (button.classList.contains(this.expandedClass)) {
        this.toggleExpandedState(button);
      }
    });
  };

  closeSubMenus = () => {
    this.menuItemsArray.forEach(menuItem => {
      this.handleClasses(menuItem, "remove", this.activeClass);
    });
    this.bottomMenuArray.forEach(menu => {
      this.closeMenu(menu);
    });
    // if top level one button is expanded, toggle expanded state
    this.topLevelOneToggleButtons.forEach(button => {
      button.classList.contains(this.expandedClass)
        ? this.toggleExpandedState(button)
        : false;
    });
    // reset bottom navigation height
    this.resetHeight(this.bottomMainMenu);
  };

  removeExpanded(targetButton) {
    this.handleClasses(targetButton, "remove", this.expandedClass);
    targetButton.setAttribute("aria-expanded", "false");
    this.buttonIcons = targetButton.querySelectorAll(".egat-icon");

    // handle icons on closebutton
    if (this.buttonIcons) {
      this.handleClasses(this.buttonIcons[0], "add", this.hiddenClass);
      this.handleClasses(this.buttonIcons[1], "remove", this.hiddenClass);
    }
  }

  expandButton(targetButton) {
    this.handleClasses(targetButton, "add", this.expandedClass);
    targetButton.setAttribute("aria-expanded", true);
    this.buttonIcons = targetButton.querySelectorAll(".egat-icon");
    // handle icons on closebutton
    if (this.buttonIcons) {
      this.handleClasses(this.buttonIcons[0], "remove", this.hiddenClass);
      this.handleClasses(this.buttonIcons[1], "add", this.hiddenClass);
    }
  }

  // toggle button classes and attributes
  toggleExpandedState = toggleButton => {
    if (toggleButton.classList.contains(this.expandedClass)) {
      this.removeExpanded(toggleButton);
    } else {
      this.expandButton(toggleButton);
    }
  };

  resetHeight(targetMenu) {
    if (window.innerWidth < 1440) {
      targetMenu.style.height = "auto";
    } else {
      {
        targetMenu.style.height = "initial";
      }
    }
  }

  getMenuHeight(menu) {
    // only execute this function of menu does not have a saved height
    if (menu.dataset.menuHeight && menu.dataset.menuHeight !== "0") {
      return;
    }
    // get hidden state
    const isHidden = menu.classList.contains(this.hiddenClass);
    // save original styles to reapply later
    const originalLeft = menu.style.left;
    const originalPosition = menu.style.position;
    const originalOverflow = menu.style.overflow;
    const originalmaxHeight = menu.style.maxHeight;

    // move and show element for calculation
    menu.classList.remove(this.hiddenClass);
    menu.style.position = "fixed";
    menu.style.left = "-9999px";
    menu.style.overflow = "visible";
    menu.style.maxHeight = "none";

    // save calculated height
    const menuHeight = menu.offsetHeight;
    menu.dataset.menuHeight = menuHeight;

    if (isHidden) {
      menu.classList.add(this.hiddenClass);
    }
    // reset styles to original values
    menu.style.position = originalPosition;
    menu.style.left = originalLeft;
    menu.style.overflow = originalOverflow;
    menu.style.maxHeight = originalmaxHeight;
  }

  // update menu height
  updateMenuHeight(thirdLevelMenu) {
    // only execute function for desktop width
    if (window.innerWidth < 1440) {
      // reset bottom navigation height
      this.resetHeight(this.bottomMainMenu);
      return;
    }

    const secondLevelMenu = thirdLevelMenu.parentElement.parentElement;
    const secondLevelMenuHeight = parseFloat(
      secondLevelMenu.dataset.menuHeight
    );
    const thirdLevelMenuHeight = parseFloat(thirdLevelMenu.dataset.menuHeight);

    // set new menuheights if submenu is higher than menu
    if (thirdLevelMenuHeight > secondLevelMenuHeight) {
      const newThirdLevelHeight = `${thirdLevelMenuHeight / 2 + 60}px`;

      if (parseFloat(newThirdLevelHeight) > secondLevelMenuHeight) {
        thirdLevelMenu.style.height = newThirdLevelHeight;
        this.bottomMainMenu.style.height = newThirdLevelHeight;
      } else {
        thirdLevelMenu.style.height = `${secondLevelMenuHeight}px`;
        this.bottomMainMenu.style.height = `${secondLevelMenuHeight + 60}px`;
      }
    }
  }

  // disable background scrolling if mobile menu is open
  toggleScrolling = () => {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    this.handleClasses(document.body, "toggle", "js-no-scrolling");

    document.documentElement.style.setProperty(
      "--scrollbar-width",
      scrollbarWidth + "px"
    );
  };

  // handle user interaction
  //
  onUserInteraction = () => {
    // click on main menu button
    this.mobileMenuButton.addEventListener("click", () => {
      // toggle scrolling
      this.toggleScrolling();
      setTimeout(() => {
        this.bottomLevelThreeMenus.forEach(thirdLevelMenu => {
          this.getMenuHeight(thirdLevelMenu);
        });
      }, 100);

      // open/close menu
      this.handleClasses(this.bottomMenuWrapper, "toggle", this.visibleClass);
      this.toggleMenu(this.mobileLevelOneMenu);

      // if mobile menu button is expanded before click, close all menus
      !this.mobileMenuButton.classList.contains(this.expandedClass)
        ? this.closeAll()
        : false;
    });

    // handle click on navigation menu buttons
    this.toggleButtonArray.forEach(toggleButton => {
      toggleButton.addEventListener("click", event => {
        // check if clicked button was expanded before click
        const currentButton = event.currentTarget;
        const isExpanded = currentButton.classList.contains(this.expandedClass);

        // handle click on top menu level one buttons
        if (currentButton.closest(".egat-navigation__top")) {
          // find bottomtwin of current menu item
          const currentIndex = this.topLevelOneMenuItems.findIndex(
            element => element === currentButton.parentElement
          );
          const bottomTwin = this.bottomLevelOneMenuItems[currentIndex];

          if (!isExpanded) {
            this.handleClasses(
              this.bottomMenuWrapper,
              "toggle",
              this.visibleClass
            );
            this.closeSubMenus();
          } else {
            this.closeSubMenus();

            // find corresponding level 2 menu
            const secondLevelMenu = bottomTwin.querySelector(
              ".egat-menu--level-2"
            );
            // find level three submenus in bottomTwin
            const thirdLevelMenuArray = Array.from(
              bottomTwin.querySelectorAll(this.levelThreeSubMenuSelector)
            );

            // save child menus' height in a data attribute
            setTimeout(() => {
              if (this.bottomMainMenu.dataset.menuHeight) {
                this.bottomMainMenu.removeAttribute("data-menu-height");
                this.bottomMainMenu.style.height = "initial";
              }
              this.getMenuHeight(this.bottomMainMenu);
              this.getMenuHeight(secondLevelMenu);

              thirdLevelMenuArray.forEach(menu => {
                this.getMenuHeight(menu);
              });
            }, 100);

            // remove expanded state from top level one buttons
            this.topToggleButtonArray.forEach(toggleButton => {
              this.removeExpanded(toggleButton);
            });
            // remove expanded state from bottom level one buttons
            // todo: trigger click on expanded buttons
            this.bottomLevelOneToggleButtons.forEach(toggleButton => {
              this.removeExpanded(toggleButton);
            });

            // expand clicked button RESET ATTRIBUTES#
            this.toggleExpandedState(currentButton);

            // add visible class on bottom menu wrapper
            this.handleClasses(
              this.bottomMenuWrapper,
              "add",
              this.visibleClass
            );

            // open second level menu
            this.openMenu(bottomTwin.querySelector(this.subMenuSelector), true);
            const bottomTwinButton = bottomTwin.querySelector(
              this.toggleButtonSelector
            );

            // toggle expanded state on level one button (relevant for mobile/tablet)
            this.toggleExpandedState(bottomTwinButton);

            this.openMenu(bottomTwin.parentElement, true);
          }
        } else {
          // click on bottom menu button
          // adjust menu height
          const currentThirdLevelMenu =
            currentButton.parentElement.querySelector(".egat-menu");

          this.resetHeight(this.bottomMainMenu);

          this.updateMenuHeight(currentThirdLevelMenu);

          // get sibling elements of button
          const levelTwoButtons = Array.from(
            currentButton.parentElement.parentElement.querySelectorAll(
              this.toggleButtonSelector
            )
          );
          const siblingButtons = levelTwoButtons.filter(
            button => button !== currentButton
          );

          // close level two sibling menus and toggle expanded state on buttons
          siblingButtons.forEach(button => {
            if (button.parentElement.querySelector(".egat-menu")) {
              this.closeMenu(
                button.parentElement.querySelector(".egat-menu"),
                true
              );

              if (button.classList.contains(this.expandedClass)) {
                this.removeExpanded(button);
              }
            }
          });

          // open corresponding level two menu
          this.toggleMenu(
            currentButton.parentElement.querySelector(".egat-menu"),
            true
          );

          this.updateMenuHeight(
            currentButton.parentElement.querySelector(".egat-menu")
          );

          // reset bottom menu height if menu is closed
          if (!currentButton.classList.contains(this.expandedClass)) {
            this.resetHeight(this.bottomMainMenu);
          }
        }
      });
    });

    // handle click on close button
    this.closeButton.addEventListener("click", () => {
      this.closeSubMenus();

      this.handleClasses(this.bottomMenuWrapper, "remove", this.visibleClass);
    });

    // close menu when user clicks elsewhere
    document.addEventListener("click", event => {
      const isClickInside = this.navigation.contains(event.target);
      if (!isClickInside) {
        this.closeSubMenus();

        this.handleClasses(this.bottomMenuWrapper, "remove", this.visibleClass);
        this.removeExpanded(this.mobileMenuButton);
      }
    });

    // show/hide top level one menu according to screenwidth
    //
    window.addEventListener("resize", () => {
      // get current window width after resize
      let timeout;
      let windowWidth;
      const delay = 250;
      // callback function to get window width
      function getDimensions() {
        windowWidth = window.innerWidth;
        return windowWidth;
      }
      // clear existent timeout
      clearTimeout(timeout);

      // call all events after timeout
      timeout = setTimeout(() => {
        getDimensions();

        // Show top level menu on desktop
        if (windowWidth >= 1440) {
          this.openMenu(this.desktopLevelOneMenu);
        } else {
          this.handleClasses(this.desktopLevelOneMenu, "add", this.hiddenClass);
        }

        if (this.bottomMenuWrapper.classList.contains(this.visibleClass)) {
          this.expandButton(this.mobileMenuButton);
          const activeMenu = this.bottomMenuWrapper.querySelector(
            ".egat-menu--level-2 .egat-menu__item.active"
          );
          if (activeMenu) {
            this.thirdLevelMenu = activeMenu.querySelector(
              this.levelThreeSubMenuSelector
            );

            if (windowWidth >= 1440) {
              setTimeout(() => {
                this.getMenuHeight(activeMenu.parentElement);
                this.getMenuHeight(this.thirdLevelMenu);
                this.updateMenuHeight(this.thirdLevelMenu);
              }, 100);
            } else {
              this.resetHeight(this.thirdLevelMenu);
              this.resetHeight(this.bottomMainMenu);
            }
          }
        }
      }, delay);
    });
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new MainMenu();
});
